export default __webpack_public_path__ + "static/media/submitted.13721442.png";